import { Tab, Tabs, alpha, CircularProgress } from '@mui/material';
import Label, { LabelColor } from '../label';

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: StatusTabFilterOption;
  loading?: boolean;
};

export type StatusTabFilterOption = Array<{
  value: string;
  label: string;
  color: LabelColor;
  count: number;
}>;

export default function StatusTabFilter({ value, onChange, options, loading }: Props) {
  return (
    <Tabs
      value={value}
      onChange={(_e, newValue) => onChange(newValue)}
      sx={{
        px: 2.5,
        boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
      }}
    >
      {options.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={tab.label}
          iconPosition="end"
          icon={
            <Label
              variant={((tab.value === 'all' || tab.value === value) && 'filled') || 'soft'}
              color={tab.color}
            >
              {loading ? <CircularProgress size={10} color="inherit" /> : tab.count}
            </Label>
          }
        />
      ))}
    </Tabs>
  );
}
